<template>
    <div>
        <DynamicImageContainer class="thumbnail" :image='image' @click='selectThumbnail'/>
    </div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";

export default {
    components: {DynamicImageContainer},
    props:['image'],
    emits:['thumbnailClickListener'],
    methods:{
        selectThumbnail(){
            this.$emit('thumbnailClickListener', this.image);
        }
    }
}
</script>

<style lang="scss" scoped>
.thumbnail{
    width: 150px;
    height: 150px;
    object-fit: cover;
    cursor: pointer;
    object-position: 50% 0;

    @media (max-width: 1580px) {
        width: 100px;
        height: 100px;
    }

    @media (max-width: 768px) {
        width: 80px;
        height: 80px;
    }
}
</style>